module.exports = __webpack_public_path__ + "static/media/990609.9e3f65a3.png";